import View from '../app/View';

import 'swiper/css/effect-fade';
import '@splidejs/splide/css/core';

import '../../components/product/product';
import '../../components/product/product-customizer';
import ProductImages from '../../components/product/product-images';
import ProductInfo from '../../components/product/product-info';
import ProductForm from '../../components/product/product-form';
import ProductActionCallouts from '../../components/product/product-action-callouts';
import AddCardModal from '../../components/product/add-card-modal';
import ProductCustomizerPlayer from '../../components/product/product-customizer-player';
import '../../components/product/product-customizer-info';
import ProductCustomizerForm from '../../components/product/product-customizer-form';
import ProductCustomizerCardForm from '../../components/product/product-customizer-card-form';
import RelatedProductOptions from '../../components/product/related-product-options';
import RelatedProductOption from '../../components/product/related-product-option';
import RelatedProductOptionsDrawer from '../../components/product/related-product-options-drawer';
import ProductImageOptions from '../../components/product/product-image-options';
import '../../components/product/product-option';
import ProductRoseOptions from '../../components/product/product-rose-options';
import ProductOptionsDrawer from '../../components/product/product-options-drawer';
import '../../components/product/product-text-options';
import ProductOptionSelect from '../../components/product/product-option-select';
import '../../components/product/product-card-button';
import ProductSubscriptionWidget from '../../components/product/product-subscription-widget';
import LockBoxEngraving from '../../components/product/lock-box-engraving';
import '../../components/product/product-slogan';
import ProductDescription from '../../components/product/product-description';
import '../../components/product/product-collection-feature';
import ProductRecommendations from '../../components/product/product-recommendations';
import '../../components/product/okendo-reviews';
import '../../components/product/image-zoom-button';
import ImageZoomModal from '../../components/product/image-zoom-modal';
import ProductFormNotifyMe from '../../components/product/product-form-notify-me';
import '../../components/product/product-shipping-callout';
import '../../components/product/product-shipping-experience';
import '../../components/product/product-video-text';
import '../../components/product/product-headline';
import '../../components/product/product-lifestyle-banner';
import ProductTickerCarousel from '../../components/product/product-ticker-carousel';
import WishlistTooltip from '../../components/product/wishlist-tooltip';
import HatboxProductOptions from '../../components/product/hatbox-product-options';
import HatboxProductOption from '../../components/product/hatbox-product-option';
import SizeGuidePdpModal from '../../components/size-guide/size-guide-pdp-modal';
import SizeGuidePdpModalTable from '../../components/size-guide/size-guide-pdp-modal-table';
import HatboxUgc from '../../components/size-guide/hatbox-ugc';

// Delivery Selection Page
import ProductDeliveryChecker from '../../components/product/product-delivery-checker';
import ZipcodeSearch from '../../components/delivery-selection/zipcode-search';

const pageView = new View();
pageView.init({
  // Add template specific components here
  ProductImages,
  ProductInfo,
  ProductForm,
  ProductActionCallouts,
  AddCardModal,
  ProductCustomizerPlayer,
  ProductCustomizerForm,
  ProductCustomizerCardForm,
  RelatedProductOptions,
  RelatedProductOption,
  RelatedProductOptionsDrawer,
  ProductImageOptions,
  ProductRoseOptions,
  ProductOptionsDrawer,
  ProductOptionSelect,
  ProductSubscriptionWidget,
  LockBoxEngraving,
  ProductDescription,
  ProductRecommendations,
  ImageZoomModal,
  ProductFormNotifyMe,
  ProductTickerCarousel,
  WishlistTooltip,
  HatboxProductOptions,
  HatboxProductOption,
  SizeGuidePdpModal,
  HatboxUgc,
  ZipcodeSearch,
  ProductDeliveryChecker,
});

const sizeGuideModalTableView = new View();
sizeGuideModalTableView.init({
  SizeGuidePdpModalTable,
});

document.addEventListener('mountmodalsizeguidetable', () => {
  sizeGuideModalTableView.mountComponents();
});
